import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@客户-设备流量*/
import React from 'react';
import * as echarts from "echarts";
import { parse } from "../../../../utils/commonUtilFunc";
import { addComma } from "../../../../utils/commonUtilFunc";
import { pieChartColor } from "../../../../utils/commonConsts";
import { withRouter } from "react-router-dom";
import AppFlowDetailInfo from "./FlowInfoSubs/AppFlowDetailInfo";
import { connect } from "dva";
import { injectIntl } from "react-intl";
var Option = _Select.Option;
var FlowInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(FlowInfo, _React$Component);
  function FlowInfo(props) {
    var _this;
    _classCallCheck(this, FlowInfo);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlowInfo).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWindowResize", function () {
      _this.setState({
        chartWidth: document.body.clientWidth > 1366 ? document.body.clientWidth - 320 : 1366 - 320
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_step_class", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_step_class",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn
        }
      });
    }); //获取具体app排行数据
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_step_apps", function () {
      _this.props.dispatch({
        type: 'ci0303Info/get_step_apps',
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn,
          top: _this.state.top,
          name: _this.state.name,
          company_id: _this.ifCompany ? _this.company_id : sessionStorage.getItem("companyId"),
          idb: _this.state.selectedIdB
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        name: e.target.value
      }, function () {
        if (this.state.name === "") {
          vm.get_step_apps();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelFlowDetailModal", function () {
      _this.setState({
        ifFlowDetailModalShow: false,
        top: "5",
        name: ""
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      _this.setState({
        top: value
      }, function () {
        _this.get_step_apps();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (element) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          containLabel: true
        },
        legend: {
          orient: 'vertical',
          right: '30%',
          data: _this.props.ci0303Info.legendNm,
          top: "10%",
          formatter: function formatter(name) {
            return name;
          }
        },
        series: [{
          name: "flow",
          type: 'pie',
          data: _this.props.ci0303Info.step_class_flow,
          itemStyle: {
            normal: {
              color: function color(params) {
                return pieChartColor[params.dataIndex % pieChartColor.length];
              },
              borderWidth: 2,
              borderColor: '#ffffff'
            }
          },
          label: {
            normal: {
              show: true,
              position: 'right',
              formatter: "{b} {d}%"
            }
          },
          center: ["30%", "50%"],
          minAngle: 3
        }],
        color: ["red", "yellow"]
      };
      element.setOption(option);
      element.resize({
        width: _this.state.chartWidth,
        height: 500
      });
    });
    _this.state = {
      ifFlowDetailModalShow: false,
      selectedAppFlow: "0",
      top: "5",
      selectedIdB: "",
      name: "",
      selectedAppName: ""
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    _this.company_id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(FlowInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var vm = this;
      this.get_step_class();
      this.element = echarts.init(document.getElementById('flow-info'));
      this.element.on('click', function (params) {
        vm.setState({
          ifFlowDetailModalShow: true,
          selectedAppFlow: params.data.value,
          selectedIdB: params.data.idb,
          selectedAppName: params.name
        }, function () {
          vm.get_step_apps();
        });
      });
      window.addEventListener('resize', this.onWindowResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChart(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      var search = parse(this.props.location.search);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "flow-info"
      }), /*#__PURE__*/React.createElement(_Modal, {
        destroyOnClose: true,
        visible: this.state.ifFlowDetailModalShow,
        title: this.state.selectedAppName + "-" + "Application traffic ranking",
        footer: null,
        onCancel: this.cancelFlowDetailModal,
        width: 925
      }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
        className: "title-device-name"
      }, "Device Name", ":", parse(this.props.location.search).device_name), /*#__PURE__*/React.createElement("div", {
        className: "title-device-info"
      }, /*#__PURE__*/React.createElement("span", null, "time slot", ":\xA0\xA0", search.start_tm, "\xA0", "to", "\xA0", search.end_tm), /*#__PURE__*/React.createElement("span", null, "Traffic type", ":\xA0\xA0", search.tunnel_dir), /*#__PURE__*/React.createElement("span", null, "Traffic size", ":\xA0", addComma(this.state.selectedAppFlow), "\xA0\xA0MB"))), /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "Please enter keywords",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_step_apps
      }, "search"), /*#__PURE__*/React.createElement(AppFlowDetailInfo, null)));
    }
  }]);
  return FlowInfo;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(FlowInfo)));